var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { Emit, Prop } from 'vue-property-decorator';
import { OutsourceReconciliationManageService } from "~/services/domain-service/outsource-reconciliation-manage.service";
var BillSurvey = /** @class */ (function (_super) {
    __extends(BillSurvey, _super);
    function BillSurvey() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            recType: '',
            recMoney: '',
            recReason: '',
        };
        _this.rules = {
            recType: [{ required: true, message: '请选择调账类型', trigger: 'change' }],
            recMoney: [{ required: true, message: '请输入调账金额', trigger: 'blur' }],
            recReason: [{ required: true, message: '请输入调账原因', trigger: 'blur' }],
        };
        return _this;
    }
    BillSurvey.prototype.refreshData = function () { };
    BillSurvey.prototype.close = function () {
        this.reset();
    };
    BillSurvey.prototype.reset = function () {
        var form = this.$refs['bill-survey'];
        form.resetFields();
    };
    BillSurvey.prototype.commitCheck = function () {
        var _this = this;
        var form = this.$refs['bill-survey'];
        form.validate(function (valid) {
            if (!valid)
                return;
            var query = {
                adjustmentAmount: _this.model.recMoney,
                accountAdjustment: _this.model.recType,
                applyDescription: _this.model.recReason,
                caseIds: [_this.rowData.id],
                confirm: 1,
            };
            _this.outsourceReconciliationManageService.accountAdjustment(query).subscribe(function (data) {
                _this.$message.success('申请成功!');
                _this.refreshData();
                _this.close();
            });
        });
    };
    __decorate([
        Dependencies(OutsourceReconciliationManageService)
    ], BillSurvey.prototype, "outsourceReconciliationManageService", void 0);
    __decorate([
        Prop({ type: Object, required: true })
    ], BillSurvey.prototype, "rowData", void 0);
    __decorate([
        Emit('refreshData')
    ], BillSurvey.prototype, "refreshData", null);
    __decorate([
        Emit('close')
    ], BillSurvey.prototype, "close", null);
    BillSurvey = __decorate([
        Component({})
    ], BillSurvey);
    return BillSurvey;
}(Vue));
export default BillSurvey;
